export const availableLanguages = [
    { value: 'af', label: 'Afrikaans' },
    { value: 'sq', label: 'Albanian' },
    { value: 'am', label: 'Amharic' },
    { value: 'ar', label: 'Arabic' },
    { value: 'hy', label: 'Armenian' },
    { value: 'as', label: 'Assamese' },
    { value: 'ay', label: 'Aymara' },
    { value: 'az', label: 'Azerbaijani' },
    { value: 'bm', label: 'Bambara' },
    { value: 'eu', label: 'Basque' },
    { value: 'be', label: 'Belarusian' },
    { value: 'bn', label: 'Bengali' },
    { value: 'bho', label: 'Bhojpuri' },
    { value: 'bs', label: 'Bosnian' },
    { value: 'bg', label: 'Bulgarian' },
    { value: 'ca', label: 'Catalan' },
    // { value: 'zhh', label: 'Cantonese' },
    { value: 'ceb', label: 'Cebuano' },
    { value: 'zh-CN', label: 'Chinese (Simplified)' },
    { value: 'zh-TW', label: 'Chinese (Traditional)' },
    { value: 'chk', label: 'Chuukese' },
    { value: 'co', label: 'Corsican' },
    { value: 'hr', label: 'Croatian' },
    { value: 'cs', label: 'Czech' },
    { value: 'da', label: 'Danish' },
    { value: 'dv', label: 'Dhivehi' },
    { value: 'doi', label: 'Dogri' },
    { value: 'nl', label: 'Dutch' },
    { value: 'en', label: 'English' },
    { value: 'eo', label: 'Esperanto' },
    { value: 'et', label: 'Estonian' },
    { value: 'ee', label: 'Ewe' },
    { value: 'fil', label: 'Filipino (Tagalog)' },
    { value: 'fi', label: 'Finnish' },
    { value: 'fr', label: 'French' },
    { value: 'fr-FR', label: 'French (French)' },
    { value: 'fr-CA', label: 'French (Canadian)' },
    { value: 'fy', label: 'Frisian' },
    { value: 'gl', label: 'Galician' },
    { value: 'ka', label: 'Georgian' },
    { value: 'de', label: 'German' },
    { value: 'el', label: 'Greek' },
    { value: 'gn', label: 'Guarani' },
    { value: 'gu', label: 'Gujarati' },
    { value: 'ht', label: 'Haitian Creole' },
    { value: 'ha', label: 'Hausa' },
    { value: 'haw', label: 'Hawaiian' },
    { value: 'he', label: 'Hebrew' },
    { value: 'hi', label: 'Hindi' },
    { value: 'hmn', label: 'Hmong' },
    { value: 'hu', label: 'Hungarian' },
    { value: 'is', label: 'Icelandic' },
    { value: 'ig', label: 'Igbo' },
    { value: 'ilo', label: 'Ilocano' },
    { value: 'id', label: 'Indonesian' },
    { value: 'ga', label: 'Irish' },
    { value: 'it', label: 'Italian' },
    { value: 'ja', label: 'Japanese' },
    { value: 'jv', label: 'Javanese' },
    { value: 'kn', label: 'Kannada' },
    { value: 'kk', label: 'Kazakh' },
    { value: 'km', label: 'Khmer' },
    { value: 'rw', label: 'Kinyarwanda' },
    { value: 'gom', label: 'Konkani' },
    { value: 'ko', label: 'Korean' },
    { value: 'kri', label: 'Krio' },
    { value: 'ku', label: 'Kurdish' },
    { value: 'ckb', label: 'Kurdish (Sorani)' },
    { value: 'ky', label: 'Kyrgyz' },
    { value: 'lo', label: 'Lao' },
    { value: 'la', label: 'Latin' },
    { value: 'lv', label: 'Latvian' },
    { value: 'ln', label: 'Lingala' },
    { value: 'lt', label: 'Lithuanian' },
    { value: 'lg', label: 'Luganda' },
    { value: 'lb', label: 'Luxembourgish' },
    { value: 'mk', label: 'Macedonian' },
    { value: 'mai', label: 'Maithili' },
    { value: 'mg', label: 'Malagasy' },
    { value: 'ms', label: 'Malay' },
    { value: 'ml', label: 'Malayalam' },
    { value: 'mt', label: 'Maltese' },
    { value: 'mi', label: 'Maori' },
    { value: 'mr', label: 'Marathi' },
    { value: 'mh', label: 'Marshallese' },
    { value: 'mni-Mtei', label: 'Meiteilon (Manipuri)' },
    { value: 'lus', label: 'Mizo' },
    { value: 'mn', label: 'Mongolian' },
    { value: 'my', label: 'Myanmar (Burmese)' },
    { value: 'ne', label: 'Nepali' },
    { value: 'no', label: 'Norwegian' },
    { value: 'ny', label: 'Nyanja (Chichewa)' },
    { value: 'or', label: 'Odia (Oriya)' },
    { value: 'om', label: 'Oromo' },
    { value: 'ps', label: 'Pashto' },
    { value: 'fa', label: 'Persian' },
    { value: 'pl', label: 'Polish' },
    { value: 'pt', label: 'Portuguese (Portugal, Brazil)' },
    { value: 'pa', label: 'Punjabi' },
    { value: 'qu', label: 'Quechua' },
    { value: 'ro', label: 'Romanian' },
    { value: 'ru', label: 'Russian' },
    { value: 'sm', label: 'Samoan' },
    { value: 'sa', label: 'Sanskrit' },
    { value: 'gd', label: 'Scots Gaelic' },
    { value: 'nso', label: 'Sepedi' },
    { value: 'sr', label: 'Serbian' },
    { value: 'st', label: 'Sesotho' },
    { value: 'sn', label: 'Shona' },
    { value: 'sd', label: 'Sindhi' },
    { value: 'si', label: 'Sinhala (Sinhalese)' },
    { value: 'sk', label: 'Slovak' },
    { value: 'sl', label: 'Slovenian' },
    { value: 'so', label: 'Somali' },
    { value: 'es', label: 'Spanish' },
    { value: 'su', label: 'Sundanese' },
    { value: 'sw', label: 'Swahili' },
    { value: 'sv', label: 'Swedish' },
    { value: 'tl', label: 'Tagalog (Filipino)' },
    { value: 'tg', label: 'Tajik' },
    { value: 'ta', label: 'Tamil' },
    { value: 'tt', label: 'Tatar' },
    { value: 'te', label: 'Telugu' },
    { value: 'th', label: 'Thai' },
    { value: 'ti', label: 'Tigrinya' },
    { value: 'to', label: 'Tongan' },
    { value: 'ts', label: 'Tsonga' },
    { value: 'tr', label: 'Turkish' },
    { value: 'tk', label: 'Turkmen' },
    { value: 'ak', label: 'Twi (Akan)' },
    { value: 'uk', label: 'Ukrainian' },
    { value: 'ur', label: 'Urdu' },
    { value: 'ug', label: 'Uyghur' },
    { value: 'uz', label: 'Uzbek' },
    { value: 'vi', label: 'Vietnamese' },
    { value: 'vis', label: 'Visayan' },
    { value: 'cy', label: 'Welsh' },
    { value: 'xh', label: 'Xhosa' },
    { value: 'yi', label: 'Yiddish' },
    { value: 'yo', label: 'Yoruba' },
    { value: 'zu', label: 'Zulu' },


    // New Language set
    { value: 'ab', label: 'Abkhaz' },
    { value: 'ace', label: 'Acehnese' },
    { value: 'ach', label: 'Acholi' },
    { value: 'alz', label: 'Alur' },
    { value: 'awa', label: 'Awadhi' },
    { value: 'ban', label: 'Balinese' },
    { value: 'ba', label: 'Bashkir' },
    { value: 'btx', label: 'Batak Karo' },
    { value: 'bts', label: 'Batak Simalungun' },
    { value: 'bbc', label: 'Batak Toba' },
    { value: 'bem', label: 'Bemba' },
    { value: 'bew', label: 'Betawi' },
    { value: 'bik', label: 'Bikol' },
    { value: 'br', label: 'Breton' },
    { value: 'bua', label: 'Buryat' },
    { value: 'yue', label: 'Cantonese' },
    { value: 'cv', label: 'Chuvash' },
    { value: 'crh', label: 'Crimean Tatar' },
    { value: 'din', label: 'Dinka' },
    { value: 'dov', label: 'Dombe' },
    { value: 'dz', label: 'Dzongkha' },
    { value: 'fj', label: 'Fijian' },
    { value: 'ff', label: 'Fulfulde' },
    { value: 'gaa', label: 'Ga' },
    { value: 'cnh', label: 'Hakha Chin' }, 
    { value: 'hil', label: 'Hiligaynon' },
    { value: 'hrx', label: 'Hunsrik' },
    { value: 'pam', label: 'Kapampangan' },
    { value: 'cgg', label: 'Kiga' },
    { value: 'ktu', label: 'Kituba' },
    { value: 'ltg', label: 'Latgalian' },
    { value: 'lij', label: 'Ligurian' },
    { value: 'li', label: 'Limburgan' }, 
    { value: 'lmo', label: 'Lombard' },
    { value: 'luo', label: 'Luo' },
    { value: 'mak', label: 'Makassar' },
    { value: 'ms-Arab', label: 'Malay (Jawi)' },
    { value: 'chm', label: 'Meadow Mari' },
    { value: 'min', label: 'Minang' },
    { value: 'nr', label: 'Ndebele (South)' },
    { value: 'new', label: 'Nepalbhasa (Newari)' }, 
    { value: 'nus', label: 'Nuer' },
    { value: 'oc', label: 'Occitan' },
    { value: 'pag', label: 'Pangasinan' },
    { value: 'pap', label: 'Papiamento' },
    { value: 'pt-PT', label: 'Portuguese (Portugal)' },
    { value: 'pt-BR', label: 'Portuguese (Brazil)' },
    { value: 'pa-Arab', label: 'Punjabi (Shahmukhi)' }, 
    { value: 'rom', label: 'Romani' },
    { value: 'rn', label: 'Rundi' },
    { value: 'sg', label: 'Sango' },
    { value: 'crs', label: 'Seychellois Creole' },
    { value: 'shn', label: 'Shan' },
    { value: 'scn', label: 'Sicilian' },
    { value: 'szl', label: 'Silesian' },
    { value: 'ss', label: 'Swati' },
    { value: 'tet', label: 'Tetum' },
    { value: 'tn', label: 'Tswana' },
    { value: 'yua', label: 'Yucatec Maya' }// tested...
];